import styled, { css } from 'styled-components';
import { PriceSummary } from './PriceSummary.style.js';
import mq from '../../../utils/mediaQueries.js';
import { Link } from '../../Link/Link.style.js';
import { Button } from '../../Button/Button.style.js';
import { isDefaultTheme, isGlobetrotter } from '../../../utils/theming.js';

// @ts-nocheck
var CardFooter = styled.div.withConfig({
  displayName: "CardFooterstyle__CardFooter",
  componentId: "sc-11bvtb1-0"
})(["", " ", " ", "{align-self:flex-end;", "}"], function (_ref) {
  var $variant = _ref.$variant;
  return $variant !== 'article' && css(["padding-top:var(--space-400);border-top:solid 1px var(--color-border-key-line);"]);
}, isDefaultTheme(css(["", ""], function (_ref2) {
  var $isPortraitCard = _ref2.$isPortraitCard,
    $footerAtBottom = _ref2.$footerAtBottom;
  return !$isPortraitCard && !$footerAtBottom && css(["", ""], mq.m(css(["width:224px;flex-shrink:0;border-top:unset;border-left:solid 1px var(--color-border-key-line);padding:0 0 0 var(--space-500);margin-left:var(--space-500);"])));
})), Button, isDefaultTheme(css(["width:100%;", ""], function (_ref3) {
  var $footerAtBottom = _ref3.$footerAtBottom,
    $isPortraitCard = _ref3.$isPortraitCard,
    $columnSpan = _ref3.$columnSpan,
    $noDescription = _ref3.$noDescription;
  var isSmallPortrait = $isPortraitCard && $columnSpan < 6;
  if ($noDescription) {
    return css(["width:auto;", ""], mq.m(css(["width:", ";"], !$footerAtBottom && !$isPortraitCard ? '100%' : 'auto')));
  }
  if ($footerAtBottom && !isSmallPortrait) {
    return css(["", ""], mq.m(css(["width:auto;"])));
  }
  return '';
})));
var Description = styled.div.withConfig({
  displayName: "CardFooterstyle__Description",
  componentId: "sc-11bvtb1-1"
})(["width:100%;font-size:1.4rem;", " ", " ", " ", "{font-size:1.4rem;}"], isGlobetrotter(css(["margin-bottom:var(--space-200);"])), isDefaultTheme(css(["", ""], function (_ref4) {
  var $isPortraitCard = _ref4.$isPortraitCard;
  return css(["", " ", ""], $isPortraitCard && css(["width:fit-content;flex:1 1 50%;"]), mq.mMax(css(["width:fit-content;flex:1 1 50%;"])));
})), mq.s(css(["flex-grow:1;"])), Link);
var InnerWrapper = styled.div.withConfig({
  displayName: "CardFooterstyle__InnerWrapper",
  componentId: "sc-11bvtb1-2"
})(["display:flex;column-gap:var(--space-500);justify-content:flex-start;align-items:flex-end;flex-wrap:wrap;", " ", " ", " ", "{position:relative;z-index:3;margin-top:var(--space-100);}", "{align-self:flex-end;", " ", " ", " ", "}"], isDefaultTheme(css(["", " ", " ", ""], function (_ref5) {
  var $variant = _ref5.$variant,
    $isPortraitCard = _ref5.$isPortraitCard,
    $footerAtBottom = _ref5.$footerAtBottom;
  return $variant === 'hotel' && !$isPortraitCard && !$footerAtBottom && css(["", ""], mq.m(css(["flex-direction:column;height:100%;text-align:center;row-gap:var(--space-400);flex-wrap:wrap;"])));
}, function (_ref6) {
  var $isPortraitCard = _ref6.$isPortraitCard;
  return css(["", " ", ""], $isPortraitCard && css(["gap:var(--space-400);align-items:flex-end;flex-wrap:wrap;"]), mq.mMax(css(["gap:var(--space-400);align-items:flex-end;flex-wrap:wrap;"])));
}, function (_ref7) {
  var $footerAtBottom = _ref7.$footerAtBottom,
    $isPortraitCard = _ref7.$isPortraitCard,
    $columnSpan = _ref7.$columnSpan,
    $noDescription = _ref7.$noDescription;
  var isSmallPortrait = $isPortraitCard && $columnSpan < 6;
  if ($noDescription) {
    return css(["justify-content:space-between;", ""], mq.m(css(["justify-content:space-between;"])));
  }
  if ($footerAtBottom && !isSmallPortrait) {
    return css(["", ""], mq.m(css(["justify-content:space-between;"])));
  }
  return '';
})), function (_ref8) {
  var $imagePosition = _ref8.$imagePosition,
    $columnSpan = _ref8.$columnSpan;
  return $imagePosition !== 'top' && $columnSpan >= 6 && css(["", " ", ""], mq.m(css(["flex-wrap:nowrap;", "{margin-bottom:unset;}"], Description)), isGlobetrotter(css(["", ""], mq.s(css(["flex-wrap:nowrap;", "{margin-bottom:unset;}"], Description)))));
}, function (_ref9) {
  var $isPortraitCard = _ref9.$isPortraitCard,
    $columnSpan = _ref9.$columnSpan,
    $footerAtBottom = _ref9.$footerAtBottom;
  return $isPortraitCard && $footerAtBottom && $columnSpan >= 6 && css(["", ""], mq.m(css(["flex-wrap:nowrap;", "{margin-bottom:unset;}"], Description)));
}, Link, PriceSummary, function (_ref10) {
  var $imagePosition = _ref10.$imagePosition,
    $columnSpan = _ref10.$columnSpan,
    $noDescription = _ref10.$noDescription;
  return ($imagePosition === 'top' || $columnSpan < 6 || $noDescription) && css(["flex-grow:1;"]);
}, mq.sMax(css(["flex-grow:1;"])), function (_ref11) {
  var $footerAtBottom = _ref11.$footerAtBottom;
  return $footerAtBottom && css(["width:unset;"]);
}, isDefaultTheme(css(["", ""], function (_ref12) {
  var $footerAtBottom = _ref12.$footerAtBottom,
    $isPortraitCard = _ref12.$isPortraitCard,
    $columnSpan = _ref12.$columnSpan,
    $noDescription = _ref12.$noDescription;
  var isSmallPortrait = $isPortraitCard && $columnSpan < 6;
  if ($noDescription) {
    return css(["flex-grow:unset;align-items:flex-start;", ""], mq.m(css(["flex-grow:unset;align-items:", ";"], !$footerAtBottom && !$isPortraitCard ? 'center' : 'flex-start')));
  }
  if ($footerAtBottom && !isSmallPortrait) {
    return css(["", ""], mq.m(css(["flex-grow:unset;align-items:flex-start;"])));
  }
  return '';
})));
var InfoScarcity = styled.div.withConfig({
  displayName: "CardFooterstyle__InfoScarcity",
  componentId: "sc-11bvtb1-3"
})(["display:flex;justify-content:center;align-items:center;font:var(--font-body-s);font-weight:700;line-height:2rem;border-radius:var(--border-radius-200);background-color:var(--color-teal-500);color:var(--color-text);padding:var(--space-200);width:100%;"]);

export { CardFooter, Description, InfoScarcity, InnerWrapper };
//# sourceMappingURL=CardFooter.style.js.map
